<template>
 	<b-container v-if="$can('view-attributes') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Attributes</h3>
                    </b-col>
                    <b-col class="buttons-create text-right">
                        <b-button variant="outline-primary" size="sm" @click="openModal('create-attribute')">New Attribute</b-button>
                        <!-- <b-button variant="outline-primary" size="sm" @click="openModal('import-update')">Import / Update</b-button> -->
                        <b-button variant="outline-primary" size="sm" @click="openModal('export-columns')">Export</b-button>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>

        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="3">
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="tables.attributes.filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                              debounce="500"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!tables.attributes.filter" @click="tables.attributes.filter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col class="text-center" cols="3">
                        <b-button v-if="tables.attributes.hasQueryClicks" variant="danger" size="sm" @click="clearQueryClicks">Clear Filters</b-button>
                    </b-col>

                    <b-col cols="5" />

                    <b-col cols="1">
                        <b-form-group>
                          <b-form-select
                            v-model="tables.attributes.perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="tables.attributes.pageOptions"
                          ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-attributes-table">
                    <b-container fluid>
                        <b-table
                            v-if="tables.attributes.ready"
                            :key="tables.attributes.key"
                            class="attributes-table"
                            responsive bordered striped
                            hover no-border-collapse
                            sticky-header="calc(100vh - 250px)"
                            head-variant="light"
                            :items="tables.attributes.items"
                            :fields="visibleFields"
                            :sort-by="tables.attributes.sortBy"
                            :sort-desc="tables.attributes.sortDesc"
                            :per-page="tables.attributes.perPage"
                            :current-page="tables.attributes.currentPage"
                            :filter="tables.attributes.filter"
                            @filtered="onFiltered"
                            :busy="tables.attributes.isBusy"
                        >

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(name)="row">
                                <b-link @click="openModal('edit-attribute', row.item)">{{ row.item.name }}</b-link>
                            </template>

                            <template v-slot:cell(items_attributes)="row">
                                {{ row.item.items_attributes.length }}
                            </template>

                            <template v-slot:cell(attributes_options)="row">
                                <span v-for="(term, index) in row.item.attributes_options" :key="term.id"><span><b-link @click="openModal('edit-term', row.item, term.value, term.id)">{{ term.value }}</b-link></span><span v-if="index +1 != row.item.attributes_options.length">, </span></span>
                                <b-button variant="outline-primary" size="sm" @click="openModal('create-term', row.item.id)"><i class="fas fa-plus"></i></b-button>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination
                          v-model="tables.attributes.currentPage"
                          :total-rows="tables.attributes.totalRows"
                          :per-page="tables.attributes.perPage"
                          align="fill"
                          size="sm"
                          class="my-0"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <modal-create-attribute
            v-if="modals['create-attribute'].active"
            @getAttributes="getAttributes"
        />

        <modal-edit-attribute
            v-if="modals['edit-attribute'].active"
            :row="modals['edit-attribute'].row"
            @getAttributes="getAttributes"
        />

        <modal-create-term
            v-if="modals['create-term'].active"
            :attributeId="modals['create-term'].attributeId"
            @getAttributes="getAttributes"
        />

        <modal-edit-term
            v-if="modals['edit-term'].active"
            :row="modals['edit-term'].row"
            :term="modals['edit-term'].term"
            :termId="modals['edit-term'].termId"
            @getAttributes="getAttributes"
        />

        <modal-export-columns
            v-if="modals['export-columns'].active"
            :fields="modals['export-columns'].fields"
            :ignores="modals['export-columns'].ignores"
            @exportExcel="exportExcel"
        />
    </b-container>
</template>

<script>
    import ModalCreateAttribute from './modals/CreateAttribute'
    import ModalEditAttribute from './modals/EditAttribute'
    import ModalCreateTerm from './modals/CreateTerm'
    import ModalEditTerm from './modals/EditTerm'
    import ModalExportColumns from '../../common/modals/ExportColumns'
    import tableColumnPreferences from '../../../../mixins/tableColumnPreferences'
 	export default {
    	name: 'attributes',

        mixins: [tableColumnPreferences],

        metaInfo() {
            return {
                title: 'Atributes',
            }
        },

    	components: {
              'modal-create-attribute': ModalCreateAttribute,
              'modal-edit-attribute': ModalEditAttribute,
              'modal-create-term': ModalCreateTerm,
              'modal-edit-term': ModalEditTerm,
              'modal-export-columns': ModalExportColumns
    	},
        data() {
            return {
                modals: {
                    'create-attribute': {
                        active: 0
                    },

                    'edit-attribute': {
                        active: 0,
                        row: []
                    },

                    'create-term': {
                        active: 0,
                        attributeId: ''
                    },

                    'edit-term': {
                        active: 0,
                        row: [],
                        term: '',
                        termId: ''
                    },

                    'export-columns': {
                        active: 0,
                        fields: [],
                        ignores: ['actions']
                    },
                },
                tables: {
                    attributes: {
                        filteredItems: [],
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500],
                        sortBy: 'date_completed',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        userFields: [],
                        fields: [
                            {
                                key: 'id',
                                label: 'ID',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'name',
                                label: 'Name',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'items_attributes',
                                label: 'Item Count',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'attributes_options',
                                label: 'Terms',
                                sortable: true,
                                visible: 1
                            },
                            // {
                            //     key: 'actions',
                            //     label: '',
                            //     thClass: 'attributes-table-style-actions',
                            //     visible: 1
                            // }
                        ],

                        items: [],
                        ready: 0
                    },
                },

                exports: {
                    cols: []
                }
            }
        },
        methods: {
            exportExcel(cols, keys) {
                let url = 'api/exports/generateexport'
                axios.post(url, {
                    rows: this.objFilter(this.tables.attributes.filteredItems, keys),
                    table: 'attributes',
                    cols: cols,
                    keys: keys
                },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
            },

            forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'attributes_Export_File_' + +new Date() + '.xlsx') //or any other extension
                document.body.appendChild(link)
                link.click()

                this.showAlertBox('success', 'File Generated', 'attributes export file generated successfully!')
            },

            openModal(modalName, row, extra, extra2) {
                let prefix = 'modal-inventory-attributes-'
                switch (modalName) {
                    case 'create-attribute':
                        this.modals[modalName].active = 1

                        break
                    case 'edit-attribute':
                        this.modals[modalName].active = 1
                        this.modals[modalName].row = Object.assign({}, row)

                        break
                    case 'create-term':
                        this.modals[modalName].active = 1
                        this.modals[modalName].attributeId = row

                        break

                    case 'edit-term':
                        this.modals[modalName].active = 1
                        this.modals[modalName].row = Object.assign({}, row)
                        this.modals[modalName].term = extra
                        this.modals[modalName].termId = extra2

                        break
                    case 'export-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = JSON.parse(JSON.stringify(this.tables.attributes.fields.filter(e => !this.modals[modalName].ignores.includes(e.key))))

                        break
                }

                if (modalName == 'adjust-columns' || modalName == 'export-columns') {
                    prefix = 'modal-common-'
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            toggleBusy() {
                this.tables.attributes.isBusy = !this.tables.attributes.isBusy
            },

            getAttributes(silent) {
                this.tables.attributes.ready = 0
                this.tables.attributes.filter = this.rememberedAttribute.filter
                this.tables.attributes.perPage = this.rememberedAttribute.perPage

                if (!silent) {
                    this.toggleBusy()
                }

                let url = 'api/inventory/attributes/getattributes'
                axios.get(url, {})
                .then((res) => {
                    this.tables.attributes.items = res.data.attributes
                    if (!this.tables.attributes.filteredItems.length) {
                        this.tables.attributes.filteredItems = res.data.attributes
                    }
                    this.tables.attributes.totalRows = this.tables.attributes.items.length
                    this.tables.attributes.ready = 1

                    if (!silent) {
                        this.toggleBusy()
                    }

                    this.setLastState()
                }, () => {
                    this.has_error = true
                })
            },

            onFiltered(filteredItems) {
                this.tables.attributes.totalRows = filteredItems.length
                this.tables.attributes.currentPage = 1
                this.tables.attributes.filteredItems = filteredItems
            },

            setLastState() {
                this.$nextTick(() => {
                    if (this.rememberedAttribute.name && this.rememberedAttribute.page) {
                        this.tables.attributes.currentPage = this.rememberedAttribute.page
                        this.$nextTick(() => {
                            this.$refs[this.rememberedAttribute.name].$el.scrollIntoView()
                        })
                    }
                })
            },

            getColSaves() {
                let url = 'api/remembertable/getcolsaves/attributes'
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            const merged = this.mergeColSaves(this.tables.attributes.fields, res.data.colSaves.column_array)
                            if (merged) {
                                this.tables.attributes.userFields = merged
                            }
                        }

                        this.getAttributes()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            saveColSaves(fields) {
                const normalized = this.normalizeColumnOrder(fields)
                this.tables.attributes.userFields = normalized
                let url = 'api/remembertable/savecolsaves'
                axios.post(url, {
                    area: 'attributes',
                    fields: this.formatColSavesPayload(normalized)
                })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
            },

            forceRerender() {
                this.tables.attributes.ready = 0
                let tempFields = this.tables.attributes.fields
                this.tables.attributes.fields = []
                this.$nextTick(() => {
                    this.tables.attributes.fields = tempFields
                    this.tables.attributes.ready = 1
                })
            }
        },

    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.attributes.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotals() {
                let totalRows = this.tables.attributes.totalRows
                let currentPage = this.tables.attributes.currentPage
                let perPage = this.tables.attributes.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.attributes.totalRows + ' rows'
            },

            visibleFields() {
                return this.buildVisibleFields(this.tables.attributes.fields, this.tables.attributes.userFields)
            }
	    },

	    mounted() {
            this.getColSaves()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-inventory-attributes-create-attribute':
                        this.modals['create-attribute'].active = 0

                        break
                    case 'modal-inventory-attributes-edit-attribute':
                        this.modals['edit-attribute'].active = 0
                        this.modals['edit-attribute'].row = []

                        break
                    case 'modal-inventory-attributes-create-term':
                        this.modals['create-term'].active = 0
                        this.modals['create-term'].attributeId = ''

                        break
                    case 'modal-inventory-attributes-edit-term':
                        this.modals['edit-term'].active = 0
                        this.modals['edit-term'].row = []
                        this.modals['edit-term'].term = ''
                        this.modals['edit-term'].termId = ''

                        break
                    case 'modal-common-export-columns':
                        this.modals['export-columns'].active = 0
                        this.modals['export-columns'].fields = []

                        break
                }
            })

            // // pusher
            // Echo.channel('table-attributes-updated')
            //     .listen('TableattributesUpdated', (e) => {
            //         this.getattributes(1)
            // })
	    }
  }
</script>
<style lang="scss">
    .vue-treeselect__control {
        // height: calc(1.5em + 0.5rem + 2px);
        // padding-top: 0.25rem;
        // padding-bottom: 0.25rem;
        // padding-left: 0.5rem;
        font-size: 0.875rem !important;

        .vue-treeselect__placeholder, .vue-treeselect__single-value {
            // line-height: 1.5
        }
    }

    .attributes-table {
        height: 75vh;
        font-size: 9pt;

        .attributes-table-style-actions {
            min-width: 120px;

            .actions-icons {
                text-align: center;
                white-space: nowrap;
            }
        }

        .attributes-table-style-phone {
            min-width: 105px;
        }

        .attributes-table-style-th-datetime {
            min-width: 110px;
        }

        .attributes-table-style-td-datetime {
            text-align: center;
        }
    }
</style>
